import util from '../util';
import { AUTH } from './actionTypes';

export default util.requestReducer(AUTH);
